<template>
	<div class='load-abris-block'>
		<div v-if='selectedLease && selectedLease.sketch_path' class='abris-exists-text'>
			<span>Абрис уже загружен</span>
			<button class='preview-btn' @click='getImage'><i class='fa fa-eye'></i></button>
		</div>

		<ImagePreviewer ref='previewer' :url='objectURL'>
			<!-- <img ref='image'> -->
		</ImagePreviewer>

		<div>
			<div class='scale-block'>
				<span class='select-label'>Масштаб </span>
				<select v-model='scale' @input='onScaleInput' class='select' :disabled='!actLpoIsDraft'>
					<option :value='5000'>1 : 5 000</option>
					<option :value='10000'>1 : 10 000</option>
					<option :value='25000'>1 : 25 000</option>
					<option :value='50000'>1 : 50 000</option>
					<option :value='100000'>1 : 100 000</option>
					<option :value='200000'>1 : 200 000</option>
					<option :value='300000'>1 : 300 000</option>
				</select>

				<p-spinner v-if='scaleIsLoading'/>
			</div>
			<label>
				<span class='custom-load-input load-abris-img' v-if='selectedLease'>{{selectedLease.sketch_path ? 'Загрузить новое изображение' : 'Загрузить изображение абриса' }}</span>
				<input style='display: none;' ref='abris-file-input' type='file' accept="image" @input='onFileInput' :disabled='!actLpoIsDraft'>
			</label>
			<span v-if='selectedLease && selectedLease.sketch_path && actLpoIsDraft' class='custom-load-input remove-btn' @click='removeFile'>Удалить изображение</span>
		</div>
	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	import ImagePreviewer from '@/lib/ImagePreviewer';

	import processJSON from '@/lib/processJSON';

	const ROOT_API = process.env.VUE_APP_ROOT_API;

	const LOAD_ABRIS_LEASE = ROOT_API + 'load_file/load_abris_lease.php';
	const REMOVE_ABRIS_ACT = ROOT_API + 'load_file/remove_abris_act.php';
	const GET_ABRIS_ACT = ROOT_API + 'load_file/get_abris_act.php';

	export default {
		name: 'LoadAbrisBlock',

		components: {
			ImagePreviewer
		},

		data: () => ({
			scale: null,
			scaleIsLoading: false,
			objectURL: null,
		}),
		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },

			...mapState('actLpo', {
				selectedLease: state => state.lease.lease
			})
		},
		methods: {
			onFileInput() {
				this.loadFile();
			},

			onScaleInput(event) {
				console.log(event?.target?.value);
				// return;

				const json_obj = [
					{
						'u': [
							{
								'tab_name': 'data_lpo_lease',
								'f_v': {
									'id': this.selectedLease.id,
									'scale': event?.target?.value
								}
							}
						]
					}
				];

				const json_str = JSON.stringify(json_obj);

				// console.log(json_str);
				// return;

				this.scaleIsLoading = true;

				return processJSON(json_str).then(res => {
					return this.getLease().then(res => {
						this.$toast.add({severity: 'success', detail: 'Масштаб абриса изменен', life: 10000});
						this.resetScale();
						this.scaleIsLoading = false;
					});;
				});
			},	

			loadFile() {
				
				const inputFile = this.$refs['abris-file-input'].files[0];

				if (!inputFile) {
					this.$toast.add({severity: 'warn', detail: 'Файл не выбран', life: 10000});
					return;
				}

				const FILE_TYPE = 'image';
				const current_type = inputFile.type.split('/')[0];

				if (current_type != FILE_TYPE) {
					this.$toast.add({severity: 'warn', detail: 'Неверный тип файла', life: 10000});
					return;
				}

				const MAX_SIZE = 10485760;
				if (inputFile.size > MAX_SIZE) {
					this.$toast.add({severity: 'warn', detail: 'Превышен максимальный размер файла (10 мб)', life: 10000});
					return;
				}

				const form = new FormData();

				form.append('abris_file', inputFile);
				// form.append('abris_file_index', this.imgList.length);
				form.append('scale', this.scale);
				form.append('lease_id', this.selectedLease.id);

				fetch(LOAD_ABRIS_LEASE, {
					credentials: 'include',
					method: 'post',
					body: form,
				})
				.then(res => res.json())
				.then(res => {

					this.$refs['abris-file-input'].value = null;

					if (res && res.code == 0) {
						this.$toast.add({severity: 'success', detail: res.text, life: 10000});
						this.getLease().then(res => {
							this.resetScale();
						});;
					}
					else if (res && (res.code == 1 || res.code == 2 || res.code == 3)) {
						this.$toast.add({severity: 'warn', detail: res.text, life: 10000});
					}
					else {
						this.$toast.add({severity: 'warn', detail: 'Ошибка', life: 10000});
					}
				})
				.catch(err => {
					throw err;
				});
			},


			removeFile() {
				const form = new FormData();
				form.append('lease_id', this.selectedLease.id);

				fetch(REMOVE_ABRIS_ACT, {
					credentials: 'include',
					method: 'post',
					body: form,
				})
				.then(res => res.json())
				.then(res => {

					if (res && res.code == 0) {
						this.$toast.add({severity: 'success', detail: res.text, life: 10000});
						this.getLease().then(res => {
							this.resetScale();
						});;
					}
					else if (res && (res.code == 1)) {
						this.$toast.add({severity: 'warn', detail: res.text, life: 10000});
					}
					else {
						this.$toast.add({severity: 'warn', detail: res.text, life: 10000});
					}
				})
				.catch(err => {
					throw err;
				});
			},


			getImage() {
				const previewer = this.$refs['previewer'];
				// previewer.open();
				// return;

				const form = new FormData();
				form.append('lease_id', this.selectedLease.id);

				fetch(GET_ABRIS_ACT, {
					credentials: 'include',
					method: 'post',
					body: form,
				})
				.then(res => res.blob())
				.then(myBlob => {

					this.myBlob = myBlob;

					previewer.open();

					const myImage = this.$refs['image'];

					this.objectURL = URL.createObjectURL(myBlob);
  				// myImage.src = objectURL;
					// console.log(res);
				})
				.catch(err => {
					throw err;
				});
			},

			resetScale() {
				this.scale = this.selectedLease?.scale;
			},

			...mapActions('actLpo', [
				'getLease'
			])
		},

		created() {
			this.getLease().then(res => {
				this.resetScale();
			});
			// console.log('selectedLease: ', this.selectedLease);
		}
	};
</script>

<style scoped>

	.load-abris-img {
		margin-bottom: 0px !important;
	}

	.abris-exists-text {
		color: green;
	}

	.custom-load-input {
		border-radius: 5px;
		display: inline-block;
		padding: 4px 14px;
		background-color: black;
		color: white;
		cursor: pointer;
		margin: 10px 0 20px 0;
	}

	.scale-block {
		margin-top: 10px;
		display: flex;
		align-items: center;
	}

	.scale-block .select-label {
		margin-right: 1rem;
	}

	.scale-block .select {
		height: 28px;
	}

	.scale-block .p-progress-spinner {
		width: 2rem;
		height: 2rem;

		margin-left: 1rem;
	}

	.remove-btn {
		margin-left: 10px;
	}

	.preview-btn {
		cursor: pointer;
		border: none;
		background-color: inherit;
	}
	.preview-btn:hover {
		color: green;
	}
</style>